import React from 'react'

const Separator = () => {
    return (
        <svg
            width="229"
            height="36"
            viewBox="0 0 229 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1 2C7.66667 4 16.4 8 18 16C20 26 27 34 36 34"
                stroke="#EAEEE9"
                strokeWidth="3"
            />
            <path
                d="M97 2C103.667 4 112.4 8 114 16C116 26 123 34 132 34"
                stroke="#EAEEE9"
                strokeWidth="3"
            />
            <path
                d="M194 2C200.667 4 209.4 8 211 16C213 26 220 34 229 34"
                stroke="#EAEEE9"
                strokeWidth="3"
            />
            <path d="M55 6L78.5 29.5" stroke="#EAEEE9" strokeWidth="3" />
            <path d="M54 29.5L77.5 6" stroke="#EAEEE9" strokeWidth="3" />
            <path d="M151 6L174.5 29.5" stroke="#EAEEE9" strokeWidth="3" />
            <path d="M150 29.5L173.5 6" stroke="#EAEEE9" strokeWidth="3" />
        </svg>
    )
}

export default Separator

